import { useState } from 'react';

export default function RisorseList() {
  const [selectedCategory, setSelectedCategory] = useState('tutti');
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const [downloadingId, setDownloadingId] = useState<number | null>(null);

  const handleDownload = async (id: number, title: string) => {
    setDownloadingId(id);
    
    // Simula il download
    setTimeout(() => {
      // Crea un link temporaneo per il download
      const link = document.createElement('a');
      link.href = '#';
      link.download = `${title.replace(/\s+/g, '_')}.pdf`;
      
      // Mostra notifica di successo
      alert(`Download avviato: ${title}`);
      
      setDownloadingId(null);
    }, 1000);
  };

  const categories = [
    { id: 'tutti', label: 'Tutte le Risorse' },
    { id: 'whitepaper', label: 'White Paper' },
    { id: 'guide', label: 'Guide Pratiche' },
    { id: 'normative', label: 'Normative ISO' },
    { id: 'template', label: 'Template Perizia' },
    { id: 'video', label: 'Video Tecnici' },
  ];

  const risorse = [
    {
      id: 1,
      title: 'Brand Capital: Dal Marketing al Patrimonio',
      description: 'Analisi tecnica della trasformazione del brand da asset intangibile a bene patrimoniale misurabile e capitalizzabile a bilancio secondo principi contabili internazionali.',
      category: 'whitepaper',
      pages: 42,
      format: 'PDF',
      icon: 'ri-file-text-line',
      color: '#E879F9',
      image: 'https://public.readdy.ai/ai/img_res/47e44837fa29ef9f64763352e51bb5f9.jpg',
    },
    {
      id: 2,
      title: 'Guida Pratica alla Valutazione del Brand',
      description: 'Metodologia step-by-step per implementare il processo di valutazione del brand capital utilizzando il metodo BCI con esempi pratici e casi reali.',
      category: 'guide',
      pages: 28,
      format: 'PDF',
      icon: 'ri-book-open-line',
      color: '#22C55E',
      image: 'https://readdy.ai/api/search-image?query=Business%20guidebook%20with%20step%20by%20step%20instructions%20and%20colorful%20infographics%20on%20wooden%20table%20with%20notebook%20and%20pen%20in%20modern%20workspace%20with%20plants%20and%20natural%20light%20professional%20flat%20lay%20photography&width=800&height=500&seq=risorse002&orientation=landscape',
    },
    {
      id: 3,
      title: 'ISO 10668: Standard Internazionale',
      description: 'Documentazione completa dello standard ISO 10668 per la valutazione monetaria del brand con interpretazioni pratiche e linee guida applicative.',
      category: 'normative',
      pages: 56,
      format: 'PDF',
      icon: 'ri-shield-check-line',
      color: '#E879F9',
      image: 'https://readdy.ai/api/search-image?query=Official%20ISO%20certification%20documents%20with%20quality%20standards%20seals%20and%20compliance%20badges%20on%20professional%20desk%20with%20organized%20folders%20in%20corporate%20office%20setting%20with%20clean%20minimalist%20design&width=800&height=500&seq=risorse003&orientation=landscape',
    },
    {
      id: 4,
      title: 'Template Perizia Giurata BCI',
      description: 'Modello professionale completo per la redazione di perizie giurate di valutazione del brand capital conformi agli standard legali e contabili italiani.',
      category: 'template',
      pages: 18,
      format: 'DOCX',
      icon: 'ri-file-edit-line',
      color: '#22C55E',
      image: 'https://readdy.ai/api/search-image?query=Professional%20legal%20document%20template%20with%20official%20stamps%20and%20signatures%20on%20elegant%20desk%20with%20fountain%20pen%20and%20leather%20folder%20in%20law%20office%20setting%20with%20sophisticated%20lighting&width=800&height=500&seq=risorse004&orientation=landscape',
    },
    {
      id: 5,
      title: 'Principi Contabili OIC 24',
      description: 'Analisi dettagliata dei principi contabili italiani OIC 24 relativi alle immobilizzazioni immateriali e alla capitalizzazione del brand a bilancio.',
      category: 'normative',
      pages: 34,
      format: 'PDF',
      icon: 'ri-article-line',
      color: '#E879F9',
      image: 'https://readdy.ai/api/search-image?query=Accounting%20principles%20documentation%20with%20financial%20statements%20and%20balance%20sheets%20on%20professional%20desk%20with%20calculator%20and%20charts%20in%20modern%20accounting%20office%20with%20organized%20workspace&width=800&height=500&seq=risorse005&orientation=landscape',
    },
    {
      id: 6,
      title: 'Video: Introduzione al Metodo BCI',
      description: 'Presentazione video completa del metodo Brand Capital Index con spiegazione delle fasi di analisi, algoritmo proprietario e casi applicativi reali.',
      category: 'video',
      pages: 0,
      format: 'MP4',
      duration: '24 min',
      icon: 'ri-video-line',
      color: '#22C55E',
      image: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20setup%20with%20camera%20equipment%20and%20lighting%20in%20modern%20studio%20with%20brand%20presentation%20on%20screen%20and%20professional%20recording%20environment%20with%20clean%20background&width=800&height=500&seq=risorse006&orientation=landscape',
    },
    {
      id: 7,
      title: 'Checklist Pre-Analisi Brand',
      description: 'Lista di controllo completa per preparare la documentazione necessaria alla valutazione del brand capital e ottimizzare il processo di analisi.',
      category: 'guide',
      pages: 12,
      format: 'PDF',
      icon: 'ri-checkbox-multiple-line',
      color: '#22C55E',
      image: 'https://readdy.ai/api/search-image?query=Business%20checklist%20with%20checkmarks%20and%20organizational%20documents%20on%20clipboard%20with%20pen%20on%20modern%20desk%20with%20laptop%20in%20bright%20office%20space%20with%20professional%20minimalist%20aesthetic&width=800&height=500&seq=risorse007&orientation=landscape',
    },
    {
      id: 8,
      title: 'Brand Equity vs Brand Capital',
      description: 'White paper comparativo che analizza le differenze concettuali e pratiche tra brand equity marketing e brand capital patrimoniale con framework operativi.',
      category: 'whitepaper',
      pages: 38,
      format: 'PDF',
      icon: 'ri-scales-line',
      color: '#E879F9',
      image: 'https://readdy.ai/api/search-image?query=Comparative%20analysis%20document%20with%20side%20by%20side%20charts%20and%20diagrams%20on%20professional%20desk%20with%20highlighters%20and%20notes%20in%20modern%20business%20office%20with%20natural%20lighting&width=800&height=500&seq=risorse008&orientation=landscape',
    },
  ];

  const filteredRisorse = selectedCategory === 'tutti' 
    ? risorse 
    : risorse.filter(r => r.category === selectedCategory);

  return (
    <section id="risorse-list" className="py-24 bg-gradient-to-b from-white to-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Filtri Categoria */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setSelectedCategory(cat.id)}
              className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                selectedCategory === cat.id
                  ? 'bg-[#E879F9] text-white shadow-lg shadow-[#E879F9]/30'
                  : 'bg-white text-[#1C1C1C] hover:bg-[#E879F9]/10 border border-[#E5E7EB]'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Grid Risorse */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {filteredRisorse.map((risorsa) => (
            <div
              key={risorsa.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 border border-[#E5E7EB] hover:border-[#E879F9]/30"
            >
              {/* Immagine */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={risorsa.image}
                  alt={risorsa.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                
                {/* Badge Formato */}
                <div className="absolute top-4 right-4 flex items-center gap-2">
                  <span className="px-3 py-1.5 bg-white/95 backdrop-blur-sm text-[#1C1C1C] text-xs font-bold rounded-full">
                    {risorsa.format}
                  </span>
                </div>

                {/* Icona Categoria */}
                <div 
                  className="absolute bottom-4 left-4 w-12 h-12 rounded-xl flex items-center justify-center shadow-lg"
                  style={{ backgroundColor: risorsa.color }}
                >
                  <i className={`${risorsa.icon} text-2xl text-white`}></i>
                </div>
              </div>

              {/* Contenuto */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#0B1F3B] mb-3 group-hover:text-[#E879F9] transition-colors">
                  {risorsa.title}
                </h3>
                
                <p className="text-[#6B7280] text-sm leading-relaxed mb-6">
                  {risorsa.description}
                </p>

                {/* Info e CTA */}
                <div className="flex items-center justify-between pt-4 border-t border-[#E5E7EB]">
                  <div className="flex items-center gap-4 text-sm text-[#6B7280]">
                    {risorsa.pages > 0 && (
                      <div className="flex items-center gap-1.5">
                        <i className="ri-file-list-line text-[#E879F9]"></i>
                        <span className="font-medium">{risorsa.pages} pagine</span>
                      </div>
                    )}
                    {risorsa.duration && (
                      <div className="flex items-center gap-1.5">
                        <i className="ri-time-line text-[#22C55E]"></i>
                        <span className="font-medium">{risorsa.duration}</span>
                      </div>
                    )}
                  </div>

                  <div className="flex gap-3">
                    <button
                      onClick={() => setExpandedId(expandedId === risorsa.id ? null : risorsa.id)}
                      className="flex-1 px-6 py-3 border-2 border-[#00A651] text-[#00A651] rounded-lg font-semibold hover:bg-[#00A651] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
                    >
                      <span>{expandedId === risorsa.id ? 'Chiudi' : 'Leggi di più'}</span>
                    </button>
                    <button
                      onClick={() => handleDownload(risorsa.id, risorsa.titolo)}
                      disabled={downloadingId === risorsa.id}
                      className="flex-1 px-6 py-3 bg-[#00A651] text-white rounded-lg font-semibold hover:bg-[#008A43] transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <span>{downloadingId === risorsa.id ? 'Download...' : 'Scarica'}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Messaggio Nessun Risultato */}
        {filteredRisorse.length === 0 && (
          <div className="text-center py-16">
            <div className="w-20 h-20 bg-[#F8F9FA] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-folder-open-line text-4xl text-[#9CA3AF]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#0B1F3B] mb-2">
              Nessuna risorsa trovata
            </h3>
            <p className="text-[#6B7280]">
              Prova a selezionare una categoria diversa
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
